<template>
	<div class="p-4 space-y-2 bg-red-100 border border-red-400 rounded-sm">
		<p>{{ error.code }} ({{ error.status }})</p>
		<p class="mt-2 text-sm">
			{{ error.message }}
		</p>
	</div>
</template>

<script lang="ts" setup>
import type { ApiError } from "@/models/ApiError";

interface Props {
	error: ApiError;
}
defineProps<Props>();
</script>
